/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, } from "react"
import { Button } from "./button"
import { Label } from "./label"
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select"
import {
    Edit3,
    Trash2,
    X,
    Grid3X3,
    ZoomIn,
    ZoomOut,
    RefreshCw,
    Sparkles,
    Plus,
    Copy,
    ChevronLeft,
    ChevronRight,
    MoreHorizontal
} from "lucide-react"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./dialog"


import { Checkbox } from "./checkbox"
import { RadioGroup, RadioGroupItem } from "./radio-group"
import { Input } from "./input"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./dropdown-menu"
import {
    NewDatePicker, Select, LucideIcon, useCRUDController, message,
    TempDataProvider, useGlobalTempStore
} from "./ot"

import { useCallback } from "react"
import { useNavigate, useSearchParams } from "react-router-dom";
import StarRating from "../ui/star"; // 請確認路徑正確

import {
    getElementPosition,
    getElementSize,
    computeLineGeom,
    nearly,
    getPriorityColor,
    getPriorityText,
    getLineStyle,
    getEdgeCenterGeom,
    formatDateTimeWithSeconds,
    getProcessType,
    getCanvasStepCount,
    getStepTypeLimit,
    checkStepLimit,
    createFormColumns
} from "./base_canvas_element_utils"
import RenderDisplayComponent from "./render_display_component"
import RenderFillComponent from "./render_fill_component"
import CanvasFlowLayout from "./canvas_flow_layout"
import { useFieldCalculation } from './hooks/use-field-calculation';
import html2canvas from 'html2canvas';



const BaseCanvasEdit2 = forwardRef(({
    formColumnApiRoute,
    elements = [],
    mode = "design", // 新增 mode prop
    onCanvasElementChange = () => { },
    onCanvasElementClick = () => { },
    onCanvasPageSelectChange = () => { },
    onCanvasPageChange = () => { },
    tools = [], // 新增 tools prop
    renderExternalBlock = () => <></>,
    propsCanvasMode = "desktop",
    showToolbar = true, // <--- 新增這行
    propsAddNewPage = null,
    autoFitWidth = false,
    editableFieldCodes = null,
}, ref) => {
    const canvasCaptureRef = useRef(null);
    // 在 BaseCanvasEdit2 組件內部，其他 hooks 之後加入：
    const { updateWithCalculation, recalculateAll } = useFieldCalculation();
    const { tempData, setItem, getItem, removeItem, clear, getOrFetchItem, version } = useGlobalTempStore();
    const navigate = useNavigate()

    // 新增 state：縮放拖拉
    const [isResizing, setIsResizing] = useState(false);
    const resizeStart = useRef({ x: 0, y: 0, width: 0, height: 0, elementId: null });

    const [pages, setPages] = useState(elements)
    // 獲取當前頁面
    const [currentPageId, setCurrentPageId] = useState(null)
    const currentPage = pages.find((page) => page.id === currentPageId)

    const [selectedElement, setSelectedElement] = useState(null)
    const [canvasElements, setCanvasElements] = useState(elements)
    const [isAIModalOpen, setIsAIModalOpen] = useState(false)
    //type SelectedType = "element" | "connection" 選擇矩型 或是 連接線
    const [selectedType, setSelectedType] = useState("element")

    // type ConnectionMode = "none" | "connecting" | "selecting-target"
    const [connectionMode, setConnectionMode] = useState("none")
    const [connectionLines, setConnectionLines] = useState([])

    // 連接狀態
    const [connectionState, setConnectionState] = useState({
        isConnecting: false,
        fromNodeId: null,
        tempLine: null,
    })


    const [dateTimeModalElement, setDateTimeModalElement] = useState(null);
    const [dateTimeModalOpen, setDateTimeModalOpen] = useState(false);
    const [isSnapToGrid, setIsSnapToGrid] = useState(true) // 預設啟用網格對齊
    const handleElementClick = (element) => {
        console.log({
            element
        })
        if (mode === "fill") return; // 填寫模式不選取
        //連接線選擇 舉行項目時，避免變更  selectedElement 所做的阻擋
        if (connectionMode === "none") {
            setSelectedElement(element)
            onCanvasElementClick(element)
        }

    }

    // 元件移動
    const [isDragging, setIsDragging] = useState(false)
    const dragOffset = useRef({ x: 0, y: 0 })
    const dragCurrentPos = useRef({ x: 0, y: 0 })

    const CANVAS_SIZES = {
        desktop: { width: 1200, height: 800, label: "桌面版", icon: "Monitor" },
        tablet: { width: 800, height: 1200, label: "平板版", icon: "Tablet" },
        mobile: { width: 375, height: 667, label: "手機版", icon: "Smartphone" },
        auto: { width: "100vw", height: "80vh", label: "自動滿版", icon: "Maximize2" }, // 新增

    };

    const [canvasMode, setCanvasMode] = useState(propsCanvasMode ?? "desktop"); // "desktop" | "tablet" | "mobile" ｜"auto"

    // fill 模式下，當外部 propsCanvasMode 改變（RWD resize）時同步更新內部 canvasMode
    // design 模式下不同步，保留後台工具列的裝置切換
    useEffect(() => {
        if (!propsCanvasMode) return
        if (mode === "fill" || mode === "fill_disable") {
            setCanvasMode(propsCanvasMode)
        }
    }, [propsCanvasMode, mode])
    // 計算橫向刻度數量（每格20px）
    const horizontalSteps = Math.ceil((CANVAS_SIZES[canvasMode]?.width ?? 600) / 20) + 1;
    // 計算縱向刻度數量
    const verticalSteps = Math.ceil((CANVAS_SIZES[canvasMode]?.height ?? 800) / 20) + 1;

    // ruler refs/state for overlay rendering
    const scrollerRef = useRef(null);
    const scaledCanvasRef = useRef(null);
    const [rulerInfo, setRulerInfo] = useState({ left: 0, top: 0, width: 0, height: 0, zoom: 1 });
    const getContentBBox = () => {
        const page = pages.find(p => p.id === currentPageId);
        if (!page) return null;
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        page.elements.forEach(el => {
            const { x, y } = getElementPosition(el, canvasMode);
            const w = Number(el?.style?.width ?? el?.width ?? 0);
            const h = Number(el?.style?.height ?? el?.height ?? 0);
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x + w);
            maxY = Math.max(maxY, y + h);
        });
        if (minX === Infinity) return null;
        const pad = 8;
        return {
            x: Math.max(0, minX - pad),
            y: Math.max(0, minY - pad),
            width: maxX - minX + pad * 2,
            height: maxY - minY + pad * 2,
        };
    };

    const captureThumbnail = async () => {
        const bbox = getContentBBox();
        if (!bbox || !canvasCaptureRef.current) return null;
        const canvas = await html2canvas(canvasCaptureRef.current, {
            backgroundColor: '#fff',
            scale: 2,              // 清晰度
            x: bbox.x,
            y: bbox.y,
            width: bbox.width,
            height: bbox.height,
            useCORS: true,
        });
        return new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    };

    useEffect(() => {
        if (!autoFitWidth) return;
        const canvasWidth = CANVAS_SIZES[canvasMode]?.width;
        if (!canvasWidth || canvasWidth === '100vw') return;

        const container = canvasCaptureRef.current;
        if (!container) return;

        const availableWidth = container.clientWidth;
        const padding = 16; // p-8 左右各 32px
        const zoom = Math.min((availableWidth - padding) / canvasWidth, 1);
        const rounded = Math.round(zoom * 100) / 100;

        setPages(prev => prev.map(p =>
            p.id === currentPageId ? { ...p, zoom: rounded } : p
        ));
    }, [autoFitWidth, canvasMode, currentPageId]);

    useEffect(() => {
        function updateRuler() {
            if (!scaledCanvasRef.current) return;
            const rect = scaledCanvasRef.current.getBoundingClientRect();
            const zoom = pages.find(p => p.id === currentPageId)?.zoom ?? 1;
            setRulerInfo({ left: Math.round(rect.left), top: Math.round(rect.top), width: Math.round(rect.width), height: Math.round(rect.height), zoom });
        }
        updateRuler();
        window.addEventListener('resize', updateRuler);
        // also update on scroll so overlay tracks canvas when the page scrolls
        window.addEventListener('scroll', updateRuler, { passive: true });
        return () => {
            window.removeEventListener('resize', updateRuler);
            window.removeEventListener('scroll', updateRuler);
        };
    }, [pages, canvasMode, currentPageId]);

    // 修改 handleMouseDown
    const handleMouseDown = (e, element) => {
        if (mode === "fill") return; // 填寫模式禁止拖拉
        e.preventDefault()
        console.log({
            element
        })
        setSelectedElement(element)
        setIsDragging(true)

        const { x, y } = getElementPosition(element, canvasMode);

        dragOffset.current = {
            x: e.clientX - x,
            y: e.clientY - y,
        }

        dragCurrentPos.current = {
            x,
            y,
        }
    }
    // 修改 handleMouseMove
    const handleMouseMove = (e) => {
        if (!isDragging || !selectedElement) return

        const newX = e.clientX - dragOffset.current.x;
        const newY = e.clientY - dragOffset.current.y;

        // If snapping is enabled, show snapped preview while dragging so the dot aligns
        const previewX = isSnapToGrid ? snapToGrid(newX) : newX;
        const previewY = isSnapToGrid ? snapToGrid(newY) : newY;

        dragCurrentPos.current = { x: previewX, y: previewY };

        const draggedElement = document.getElementById(`element-${selectedElement?.id}`);
        if (draggedElement) {
            draggedElement.style.left = `${previewX}px`;
            draggedElement.style.top = `${previewY}px`;
            draggedElement.style.transform = "";
        }
    }
    // 修改 handleMouseUp
    const handleMouseUp = () => {
        if (!isDragging || !selectedElement) return

        setIsDragging(false)

        const { x, y } = dragCurrentPos.current

        const finalX = isSnapToGrid ? snapToGrid(x) : x
        const finalY = isSnapToGrid ? snapToGrid(y) : y

        setPages(prevPages =>
            prevPages.map((page) => {
                if (page.id !== currentPageId) return page
                const updatedElements = page.elements.map((el) =>
                    el?.id === selectedElement?.id
                        ? {
                            ...el,
                            // 新格式：如果 x/y 是 responsive objects, update the current canvasMode slot
                            x: typeof el.x === "object"
                                ? { ...el.x, [canvasMode]: finalX }
                                : finalX,
                            y: typeof el.y === "object"
                                ? { ...el.y, [canvasMode]: finalY }
                                : finalY,
                            // 舊格式也更新
                            ...(typeof el.x !== "object" ? { x: finalX } : {}),
                            ...(typeof el.y !== "object" ? { y: finalY } : {}),
                            // 更新 legacy 值
                            ...(el?.xLegacy !== undefined ? { xLegacy: finalX } : { xLegacy: finalX }),
                            ...(el?.yLegacy !== undefined ? { yLegacy: finalY } : { yLegacy: finalY }),
                        }
                        : el
                )
                return { ...page, elements: updatedElements }
            })
        )

        const draggedElement = document.getElementById(`element-${selectedElement?.id}`)
        if (draggedElement) {
            draggedElement.style.transform = ''
        }
    }
    // 元件拖曳新增
    const getDefaultContentByType = (type) => {
        switch (type) {
            case "datetime":
                return "";
            case "qrcode":
                return "https://www.facebook.com/F7479641/?locale=zh_TW";
            default:
                return "";
        }
    };
    // 定義不同類型元件的預設樣式
    const getDefaultStyleByType = (type) => {
        switch (type) {
            case "title":
                return {
                    fontSize: "24px",
                    fontWeight: "bold",
                    textAlign: "center",
                    backgroundColor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }
            case "text-content":
                return {
                    fontSize: "16px",
                    lineHeight: "1.5",
                    padding: "10px",
                    backgroundColor: "#fff",
                }
            case "image":
                return {
                    backgroundColor: "#f0f0f0",
                    color: "#888",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }
            case "hashtag":
                return {
                    // backgroundColor: "#e8f5e8",
                    color: "#2d5a2d",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }
            case "button":
                return {
                    backgroundColor: "#fff",
                    // color: "#000",
                    // fontSize: "18px",
                    // fontWeight: "bold",
                    // borderRadius: "8px",
                    display: "flex",
                    // alignItems: "center",
                    justifyContent: "center",
                    // cursor: "pointer",
                }
            case "datetime":
                return {
                    fontSize: "16px",
                    padding: "10px",
                    backgroundColor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                };
            case "qrcode":
                return {
                    backgroundColor: "#f0f0f0",
                    color: "#888",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 150,
                    height: 150,
                }
            case "rectangle":
                return {
                    backgroundColor: "#3b82f6",
                    border: "3px solid #9fb5ffff",
                    color: "black",
                    fontSize: "16px",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 80,
                    height: 60,
                }
            case "straight-line":
                return {
                    backgroundColor: "transparent",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    // border: "3px solid #1e40af",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 80,
                    height: 60,
                }
            case "number_input":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    // border: "1px solid #000",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 100,
                    // height: 60,
                }
            case "dropdown":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    // border: "1px solid #000",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                    height: 60,
                }
            case "checkbox":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 100,
                }
            case "radio_button":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 100,
                }
            case "datetime_picker":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                }
            case "multi_select_list":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                }
            case "textarea":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                    height: 100,
                }
            case "email_input":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                }
            case "phone_input":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                }
            case "url_input":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                }
            case "password_input":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                }
            case "flow_node":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 320,
                    height: 210,
                    connections: []
                }
            case "start_node":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                    height: 120,
                    connections: []
                }
            case "end_node":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                    height: 120,
                    connections: []
                }
            case "process_node":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                    height: 120,
                    connections: []
                }
            case "decision_node":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: 200,
                    height: 120,
                    connections: []
                }
            case "card":
                return {
                    backgroundColor: "#fff",
                    color: "#000",
                    cursor: "pointer",
                    width: 400,
                    height: 400,
                }
            case "flow_line":
                return {
                    backgroundColor: "transparent",
                    color: "#000",
                }
            default:
                return {

                }
        }
    }

    // 修改 handleDropOnCanvas
    const handleDropOnCanvas = (e) => {
        e.preventDefault()
        const type = e.dataTransfer.getData("component-type")
        const component_definitions_id = parseInt(e.dataTransfer.getData("component-id"), 10)
        if (!type) return

        const canvasRect = e.currentTarget.getBoundingClientRect()
        let x = e.clientX - canvasRect.left
        let y = e.clientY - canvasRect.top

        if (isSnapToGrid) {
            x = snapToGrid(x)
            y = snapToGrid(y)
        }

        const newId = `${type}-${Date.now()}`
        let newElement = {
            component_definitions_id: component_definitions_id,
            id: newId,
            type,
            content: getDefaultContentByType(type),
            // 新格式
            x: { desktop: x, tablet: x, mobile: x },
            y: { desktop: y, tablet: y, mobile: y },
            // 舊格式
            xLegacy: x,
            yLegacy: y,
            width: 300,
            height: 60,
            style: getDefaultStyleByType(type),
        }
        console.log({
            newElement
        })
        // 📌 節點類型需要限制檢查
        if (
            type === "start_node" ||
            type === "end_node" ||
            type === "process_node" ||
            type === "decision_node"
        ) {
            (async () => {
                const nodeTypeNameMap = {
                    start_node: "開始節點",
                    process_node: "處理節點",
                    end_node: "結束節點",
                    decision_node: "判斷節點",
                    flow_node: "流程節點"
                }

                // 1. 判斷流程類型
                const processType = getProcessType()

                // 2. 取得當前畫布的步驟數量
                let canvasStepCount = {
                    start_node: 0,
                    process_node: 0,
                    end_node: 0,
                    decision_node: 0,
                }
                setPages((pre) => {
                    canvasStepCount = getCanvasStepCount(pre)
                    return pre
                })

                // 3. 取得對應流程的節點限制
                const stepTypeLimit = getStepTypeLimit(processType)

                // 4. 判斷是否超出限制
                const stepCheck = checkStepLimit(canvasStepCount, stepTypeLimit)
                if (stepCheck[type] === 1) {
                    message.error(`${nodeTypeNameMap[type] || type} 已達上限，無法新增`)
                    return // ❌ 超過上限，直接 return，不會新增
                }

                // 5. 呼叫 API 建立對應 form_column
                let nodes = [{ ...newElement }]
                // nodes = await createFormColumns(nodes, formColumnController)
                let newElementWithData = nodes[0]

                // 6. 更新到當前 page
                setPages((prev) =>
                    prev.map((page) =>
                        page.id !== currentPageId
                            ? page
                            : { ...page, elements: [...page.elements, newElementWithData] }
                    )
                )
            })()
            return // 📌 確保不會繼續跑下面 else
        }

        // 📌 線段類型
        if (type === "straight-line") {
            newElement = {
                ...newElement,
                width: 0,
                height: 0,
            }
            setSelectedElement(newElement)
            setPages(prev =>
                prev.map((page) =>
                    page.id !== currentPageId
                        ? page
                        : { ...page, elements: [...page.elements, newElement] }
                )
            )
            setConnectionMode("connecting")
            return
        }
        if (type === "rectangle") {
            newElement = {
                ...newElement,
                response_id: null,
            }
        }

        // 📌 其他類型
        setConnectionMode("none")
        setPages(prev =>
            prev.map((page) =>
                page.id !== currentPageId
                    ? page
                    : { ...page, elements: [...page.elements, newElement] }
            )
        )
    }

    // 處理拖放到 card (群組) 的情況：接收 elementTypeData, 相對於 content 的座標，以及 parentId
    const handleDropIntoCard = (elementTypeData, relPos, parentId) => {
        if (!elementTypeData) return
        const type = elementTypeData.type || elementTypeData.componentType || null
        const component_definitions_id = Number((elementTypeData.component_definitions_id ?? elementTypeData.componentId ?? elementTypeData.component_id) || 0)
        const newId = `${type || 'el'}-${Date.now()}`

        let relX = Math.max(0, Math.round(relPos.x))
        let relY = Math.max(0, Math.round(relPos.y))

        if (isSnapToGrid) {
            relX = snapToGrid(relX)
            relY = snapToGrid(relY)
        }

        const newElement = {
            component_definitions_id: component_definitions_id,
            id: newId,
            type: type,
            content: getDefaultContentByType(type),
            // 在群組內存放為相對座標（同步三個尺寸）
            x: { desktop: relX, tablet: relX, mobile: relX },
            y: { desktop: relY, tablet: relY, mobile: relY },
            xLegacy: relX,
            yLegacy: relY,
            width: elementTypeData.width ?? 300,
            height: elementTypeData.height ?? 60,
            style: getDefaultStyleByType(type),
            parentId: parentId,
        }

        setPages(prev => prev.map(page => {
            if (page.id !== currentPageId) return page
            const parent = page.elements.find(el => el.id === parentId)
            const updatedElements = [...page.elements, newElement]
            const nextElements = parent
                ? updatedElements.map(el => el.id === parentId ? { ...el, children: Array.from(new Set([...(el.children || []), newId])) } : el)
                : updatedElements

            return { ...page, elements: nextElements }
        }))
    }
    // 元件刪除
    const handleDeleteSelectedElement = () => {
        if (mode === "fill") return; // 填寫模式禁止刪除
        if (!selectedElement) return
        setPages(prev =>
            prev.map((page, idx) =>
                page.id !== currentPageId
                    ? page
                    : {
                        ...page,
                        elements: page.elements.filter(el => {
                            // flow_node: 刪除自己與所有連接的 flow_line
                            if (selectedElement?.type === "flow_node" ||
                                selectedElement?.type === "start_node" ||
                                selectedElement?.type === "end_node" ||
                                selectedElement?.type === "process_node" ||
                                selectedElement?.type === "decision_node") {
                                // 刪除自己與所有 fromId/toId 為自己 id 的 flow_line
                                if (el?.id === selectedElement?.id) return false
                                if (el?.type === "flow_line" && (el?.fromId === selectedElement?.id || el?.toId === selectedElement?.id)) return false
                                return true
                            }
                            // 其他元件只刪自己
                            return el?.id !== selectedElement?.id
                        })
                    }
            )
        );
        setSelectedElement(null)
    }
    // 元件內容編輯
    const [editingElementId, setEditingElementId] = useState(null)
    const [editingContent, setEditingContent] = useState("")
    const [dateTimeModalTempContent, setDateTimeModalTempContent] = useState("");
    const handleFinishEditing = () => {
        // setCanvasElements((prev) =>
        //     prev.map((el) =>
        //     el?.id === editingElementId ? { ...el, content: editingContent } : el
        //     )
        // )
        setPages(prev =>
            prev.map((page, idx) =>
                page.id !== currentPageId
                    ? page
                    : {
                        ...page,
                        elements: page.elements.map(el =>
                            el?.id === editingElementId
                                ? { ...el, content: editingContent }
                                : el
                        )
                    }
            )
        );
        setEditingElementId(null)
        setEditingContent("")
    }
    const handleSaveDateTimeModal = () => {
        const updated = {
            ...dateTimeModalElement,
            content: dateTimeModalTempContent
        };
        setPages(prev =>
            prev.map(page =>
                page.id !== currentPageId
                    ? page
                    : {
                        ...page,
                        elements: page.elements.map(el =>
                            el?.id === updated.id ? updated : el
                        )
                    }
            )
        );
        setDateTimeModalOpen(false);
        setDateTimeModalElement(null);
        setDateTimeModalTempContent("");
    };

    //矩型新增節點
    // ✅ 只依賴 pages / currentPageId / connectionLines
    // 修改 addChildNode
    const addChildNode = (parentId, direction, component_definitions_id) => {
        setPages(prevPages => {
            const pageIdx = prevPages.findIndex(p => p.id === currentPageId);
            if (pageIdx === -1) return prevPages;

            const page = prevPages[pageIdx];
            const parent = page.elements.find(el => el?.id === parentId);

            if (!parent) return prevPages;

            const { x: px, y: py } = getElementPosition(parent, canvasMode);

            const newElement = {
                component_definitions_id: component_definitions_id,
                id: `rectangle-${Date.now()}`,
                type: "rectangle",
                content: "新節點",
                x: { desktop: px, tablet: px, mobile: px },
                y: { desktop: py, tablet: py, mobile: py },
                xLegacy: px,
                yLegacy: py,
                width: 80,
                height: 40,
                style: {
                    backgroundColor: "#6b7280",
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "bold",
                    border: "2px solid #333",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                },
            };

            const H_OFFSET = 110;
            const V_OFFSET = 100;

            switch (direction) {
                case "same-level-left":
                    newElement.x[canvasMode] = px - H_OFFSET;
                    newElement.y[canvasMode] = py;
                    newElement.xLegacy = px - H_OFFSET;
                    newElement.yLegacy = py;
                    break;
                case "same-level-right":
                    newElement.x[canvasMode] = px + H_OFFSET;
                    newElement.y[canvasMode] = py;
                    newElement.xLegacy = px + H_OFFSET;
                    newElement.yLegacy = py;
                    break;
                case "bottom":
                    newElement.x[canvasMode] = px;
                    newElement.y[canvasMode] = py + V_OFFSET;
                    newElement.xLegacy = px;
                    newElement.yLegacy = py + V_OFFSET;
                    break;
                case "top":
                    newElement.x[canvasMode] = px;
                    newElement.y[canvasMode] = py - V_OFFSET;
                    newElement.xLegacy = px;
                    newElement.yLegacy = py - V_OFFSET;
                    break;
                default:
                    break;
            }

            let newLines = [];
            if (direction === "bottom") {
                newLines.push({
                    id: `line-${Date.now()}`,
                    from: parentId,
                    to: newElement.id,
                    type: "arrow-line",
                    lineStyle: "solid",
                    arrowType: "right",
                });
            } else {
                const parentConn = connectionLines.find(line => line.to === parentId);
                if (parentConn) {
                    newLines.push({
                        id: `line-${Date.now()}`,
                        from: parentConn.from,
                        to: newElement.id,
                        type: "arrow-line",
                        lineStyle: "solid",
                        arrowType: "right",
                    });
                }
            }

            const updatedPage = {
                ...page,
                elements: [...page.elements, newElement],
            };

            if (newLines.length) {
                setConnectionLines(prev => [...prev, ...newLines]);
            }

            setSelectedElement(newElement);
            setSelectedType("element");

            const nextPages = [...prevPages];
            nextPages[pageIdx] = updatedPage;
            return nextPages;
        });
    };

    // 開始連線 flow_line
    const startConnection = useCallback(
        (element) => {
            let fromNodeId = element?.id
            if (!element) return

            const fromScreenX = element.x + 320
            const fromScreenY = element.y + 100
            setConnectionState({
                isConnecting: true,
                fromNodeElement: element,
                fromNodeId,
                tempLine: {
                    x1: fromScreenX,
                    y1: fromScreenY,
                    x2: fromScreenX,
                    y2: fromScreenY,
                },
            })
        },
        [pages],
    )
    // 完成連線  flow_line
    const finishConnection = useCallback(
        (toNodeElement) => {
            if (connectionState?.isConnecting && connectionState?.fromNodeElement && connectionState?.fromNodeElement.id !== toNodeElement.id) {

            }
            setPages(prev => prev.map(page => {
                if (page.id !== currentPageId) return page;

                const fromEl = connectionState?.fromNodeElement;
                const toEl = toNodeElement; // 當前點擊的矩形

                if (!fromEl || !toEl) return page;

                const { bbox, rel } = getEdgeCenterGeom(fromEl, toEl, canvasMode, /*padding=*/0);

                return {
                    ...page,
                    elements: [
                        ...page.elements,
                        {
                            id: `flow-line-${Date.now()}`,
                            type: "flow_line",
                            // 關聯
                            fromId: fromEl?.id,
                            toId: toEl?.id,
                            // 外框位置與尺寸（容器 div 會用這些）
                            x: bbox?.left,
                            y: bbox?.top,
                            width: bbox?.width,
                            height: bbox?.height,
                            style: {
                                // ...(el?.style || {}),
                                width: bbox.width,
                                height: bbox.height,
                            },
                            // 端點（相對於外框）供 SVG 繪線使用
                            relP1: rel?.p1,
                            relP2: rel?.p2,
                            // 預設線型與箭頭（可依你 UI 再改）
                            // lineStyle: el?.lineStyle ?? "solid",
                            // arrowType: el?.arrowType ?? "right",
                        }
                    ]
                }
            }));
            setConnectionState({
                isConnecting: false,
                fromNodeId: null,
                fromNodeElement: null,
                tempLine: null,
            })
        },
        [connectionState],
    )

    // 取消連線 flow_line
    const cancelConnection = useCallback(() => {
        setConnectionState({
            isConnecting: false,
            fromNodeId: null,
            tempLine: null,
        })
    }, [])
    // 修改 createConnectedNode
    const createConnectedNode = useCallback(
        (fromNodeId) => {
            setPages(prevPages => {
                const pageIdx = prevPages.findIndex(p => p.id === currentPageId);
                if (pageIdx === -1) return prevPages;

                const page = prevPages[pageIdx];
                const fromNode = page.elements.find(el => el?.id === fromNodeId);

                if (!fromNode) return prevPages;

                const { x: fx, y: fy } = getElementPosition(fromNode, canvasMode);

                const newNode = {
                    id: `flow-node-${Date.now()}`,
                    type: "flow_node",
                    title: "新流程",
                    x: { desktop: fx + 400, tablet: fx + 400, mobile: fx + 400 },
                    y: { desktop: fy, tablet: fy, mobile: fy },
                    xLegacy: fx + 400,
                    yLegacy: fy,
                    width: 320,
                    height: 210,
                    style: getDefaultStyleByType("flow_node"),
                };

                const { bbox, rel } = getEdgeCenterGeom(fromNode, newNode, canvasMode, 0);

                const newLine = {
                    id: `flow-line-${Date.now()}`,
                    type: "flow_line",
                    fromId: fromNode.id,
                    toId: newNode.id,
                    x: bbox.left,
                    y: bbox.top,
                    width: bbox.width,
                    height: bbox.height,
                    style: {
                        width: bbox.width,
                        height: bbox.height,
                        lineStyle: "solid",
                        arrowType: "right",
                    },
                    relP1: rel?.p1,
                    relP2: rel?.p2,
                };

                const updatedPage = {
                    ...page,
                    elements: [...page.elements, newNode, newLine],
                };

                setSelectedElement(newNode);

                const nextPages = [...prevPages];
                nextPages[pageIdx] = updatedPage;
                return nextPages;
            });
        },
        [currentPageId, getDefaultStyleByType, getEdgeCenterGeom, canvasMode]
    );


    // const canvasElements = currentPage?.elements || []
    // 新增頁面
    const addNewPage = () => {
        if (propsAddNewPage) {
            propsAddNewPage();
            return;
        }
        const newPageId = `page-${Date.now()}`
        const newPage = {
            id: newPageId,
            name: `頁面 ${pages.length + 1}`,
            elements: [],
        }
        setPages((prev) => [...prev, newPage])
        setCurrentPageId(newPageId)
        setSelectedElement(null)
    }
    // 複製頁面
    const duplicatePage = (pageId) => {
        const pageToClone = pages.find((page) => page.id === pageId)
        if (pageToClone) {
            const newPageId = `page-${Date.now()}`
            const clonedElements = pageToClone.elements.map((element) => ({
                ...element,
                id: `${element?.id}-copy-${Date.now()}`,
            }))
            const newPage = {
                id: newPageId,
                name: `${pageToClone.name} 副本`,
                elements: clonedElements,
            }
            setPages((prev) => [...prev, newPage])
            setCurrentPageId(newPageId)
            setSelectedElement(null)
        }
    }
    // 刪除頁面
    const deletePage = (pageId) => {
        if (pages.length > 1) {
            const pageIndex = pages.findIndex((page) => page.id === pageId)
            setPages((prev) => prev.filter((page) => page.id !== pageId))

            // 如果刪除的是當前頁面，切換到其他頁面，這裡目前有 bug
            if (pageId === currentPageId) {
                const newCurrentPage = pages[pageIndex > 0 ? pageIndex - 1 : pageIndex + 1]
                setCurrentPageId(newCurrentPage.id)
            }
            setSelectedElement(null)
        }
    }
    // 重命名頁面
    const renamePage = (pageId, newName) => {
        setPages((prev) => prev.map((page) => (page.id === pageId ? { ...page, name: newName } : page)))
    }
    // 切換到上一頁
    const goToPreviousPage = () => {
        const currentIndex = pages.findIndex((page) => page.id === currentPageId)
        if (currentIndex > 0) {
            setCurrentPageId(pages[currentIndex - 1].id)
            setSelectedElement(null)
        }
    }
    // 切換到下一頁
    const goToNextPage = () => {
        const currentIndex = pages.findIndex((page) => page.id === currentPageId)
        if (currentIndex < pages.length - 1) {
            setCurrentPageId(pages[currentIndex + 1].id)
            setSelectedElement(null)
        }
    }
    // 清除當前頁面內容
    const handleClearCurrentPage = () => {
        setPages(prev =>
            prev.map(page =>
                page?.id === currentPageId && Array.isArray(page?.elements)
                    ? { ...page, elements: [] }
                    : page
            )
        )
    }
    // 使用漂亮的 Modal 確認（取代 window.confirm）
    const [isClearConfirmOpen, setIsClearConfirmOpen] = useState(false)
    const handleClearCurrentPageConfirm = () => {
        if (mode === "fill") return; // 填寫模式禁止
        setIsClearConfirmOpen(true)
    }
    const confirmClearCurrentPage = () => {
        handleClearCurrentPage()
        setIsClearConfirmOpen(false)
    }
    const cancelClearCurrentPage = () => {
        setIsClearConfirmOpen(false)
    }
    // 是否顯示當前頁面格線
    const handleShowCurrentPageGrid = () => {
        setPages(prev =>
            prev.map(page =>
                page.id === currentPageId
                    ? { ...page, showGrid: !(page?.showGrid ?? true) }
                    : page
            )
        );
    }
    // 當前頁面畫布放大縮小
    const handleZoomChange = (newZoom) => {
        setPages(prevPages =>
            prevPages.map(page =>
                page.id === currentPageId
                    ? { ...page, zoom: newZoom }
                    : page
            )
        )
    }
    // 重整頁面並恢復預設
    const handleResetCurrentPageView = () => {
        setPages(prevPages =>
            prevPages.map(page =>
                page.id === currentPageId
                    ? {
                        ...page,
                        zoom: 1,
                        showGrid: true
                    }
                    : page
            )
        );
        setSelectedElement(null);
        setEditingElementId(null);
        setEditingContent("");
    };

    // 拖拉縮放開始
    const handleResizeMouseDown = (e, element) => {
        e.stopPropagation();
        setIsResizing(true);
        resizeStart.current = {
            x: e.clientX,
            y: e.clientY,
            width: getElementSize(element, canvasMode).width,
            height: getElementSize(element, canvasMode).height,
            elementId: element?.id,
        };
    };

    // 拖拉縮放移動
    const handleResizeMouseMove = (e) => {
        if (!isResizing || !resizeStart.current.elementId) return;
        const dx = e.clientX - resizeStart.current.x;
        const dy = e.clientY - resizeStart.current.y;
        const newW = Math.max(resizeStart.current.width + dx, 20);
        const newH = Math.max(resizeStart.current.height + dy, 20);
        setPages(prevPages =>
            prevPages.map(page => {
                if (page.id !== currentPageId) return page;
                return {
                    ...page,
                    elements: page.elements.map(el => {
                        if (el.id !== resizeStart.current.elementId) return el;
                        // 新格式：width/height 用 object 各裝置獨立儲存
                        // 舊格式數字先展開成三裝置 object，再只更新當前裝置
                        const prevW = typeof el.width === "object" && el.width !== null
                            ? el.width
                            : { desktop: el.width ?? 300, tablet: el.width ?? 300, mobile: el.width ?? 300 }
                        const prevH = typeof el.height === "object" && el.height !== null
                            ? el.height
                            : { desktop: el.height ?? 60, tablet: el.height ?? 60, mobile: el.height ?? 60 }
                        // style.width/height 同樣升格為 object
                        const prevStyleW = typeof el.style?.width === "object" && el.style?.width !== null
                            ? el.style.width
                            : { desktop: el.style?.width ?? prevW.desktop, tablet: el.style?.width ?? prevW.tablet, mobile: el.style?.width ?? prevW.mobile }
                        const prevStyleH = typeof el.style?.height === "object" && el.style?.height !== null
                            ? el.style.height
                            : { desktop: el.style?.height ?? prevH.desktop, tablet: el.style?.height ?? prevH.tablet, mobile: el.style?.height ?? prevH.mobile }
                        return {
                            ...el,
                            style: {
                                ...(el.style || {}),
                                width: { ...prevStyleW, [canvasMode]: newW },
                                height: { ...prevStyleH, [canvasMode]: newH },
                            },
                            width: { ...prevW, [canvasMode]: newW },
                            height: { ...prevH, [canvasMode]: newH },
                        }
                    })
                };
            })
        );
    };

    // 拖拉縮放結束
    const handleResizeMouseUp = () => {
        setIsResizing(false);
        resizeStart.current = { x: 0, y: 0, width: 0, height: 0, elementId: null };
    };
    // 填寫模式下更新內容
    function updateElementContent(element, value) {
        // setPages(prev =>
        //     prev.map(page =>
        //         page.id !== currentPageId
        //             ? page
        //             : {
        //                 ...page,
        //                 elements: page.elements.map(el =>
        //                     el?.id === element?.id
        //                         ? { ...el, content: value }
        //                         : el
        //                 )
        //             }
        //     )
        // );
        setPages(prev =>
            prev.map(page => {
                if (page.id !== currentPageId) return page;

                // 取得當前頁面的所有元件
                const currentElements = page.elements;

                // 使用計算 hook 更新元件並重新計算依賴
                const updatedElements = updateWithCalculation(element, value, currentElements, getItem);

                return {
                    ...page,
                    elements: updatedElements
                };
            })
        );
    }
    // --- 群組歸屬變更：精準移入/移出群組卡片 ---
    const GRID_SIZE = 20
    const CARD_INNER_PADDING = 16
    const CARD_HEADER_HEIGHT = 80

    const snapToGrid = (v) => Math.round(v / GRID_SIZE) * GRID_SIZE

    // Robust helpers to read element coordinates (no use of `position`)
    const _getXYFromElement = (el) => {
        if (!el) return { x: 0, y: 0 }
        // Priority: x (responsive object or number) -> xLegacy
        let x = 0
        let y = 0

        if (el.x != null) {
            if (typeof el.x === 'object') {
                x = Number(el.x[canvasMode] ?? el.x.desktop ?? Object.values(el.x)[0] ?? 0)
            } else {
                x = Number(el.x)
            }
        } else {
            x = Number(el.xLegacy ?? 0)
        }

        if (el.y != null) {
            if (typeof el.y === 'object') {
                y = Number(el.y[canvasMode] ?? el.y.desktop ?? Object.values(el.y)[0] ?? 0)
            } else {
                y = Number(el.y)
            }
        } else {
            y = Number(el.yLegacy ?? 0)
        }

        return { x, y }
    }

    const computeAbsolutePosition = (el) => {
        if (!el) return { x: 0, y: 0 }
        const currentPageElements = pages.find(p => p.id === currentPageId)?.elements || []

        // if no parent, return its absolute coords (prefer x/y if present)
        if (!el.parentId) {
            return _getXYFromElement(el)
        }

        const parent = currentPageElements.find(p => p.id === el.parentId)
        if (!parent) {
            return _getXYFromElement(el)
        }

        // child coordinates are stored in x/y (when inside a parent they should be relative)
        const parentXY = _getXYFromElement(parent)
        const childXY = _getXYFromElement(el)
        const absX = parentXY.x + CARD_INNER_PADDING + childXY.x
        const absY = parentXY.y + CARD_HEADER_HEIGHT + childXY.y
        return { x: absX, y: absY }
    }

    const handleChangeContainer = (newParentId) => {
        if (!selectedElement) return
        const movingEl = selectedElement
        const absPos = computeAbsolutePosition(movingEl)

        // Only update the moving element's parentId and coordinates; do not modify other elements' children lists
        setPages((prevPages) => prevPages.map(page => {
            if (page.id !== currentPageId) return page
            const updatedElements = page.elements.map(el => {
                if (el.id !== movingEl.id) return el

                // moving out to top-level
                if (!newParentId) {
                    const newX = snapToGrid(absPos.x)
                    const newY = Math.max(0, snapToGrid(absPos.y))
                    return {
                        ...el,
                        parentId: null,
                        x: { desktop: newX, tablet: newX, mobile: newX },
                        y: { desktop: newY, tablet: newY, mobile: newY },
                        xLegacy: newX,
                        yLegacy: newY,
                    }
                }

                // moving into new parent: place at top-left inside parent (relative coords 0,0)
                const newParent = page.elements.find(p => p.id === newParentId)
                if (!newParent) return el
                const relX = 0
                const relY = 0

                return {
                    ...el,
                    parentId: newParentId,
                    x: { desktop: relX, tablet: relX, mobile: relX },
                    y: { desktop: relY, tablet: relY, mobile: relY },
                    xLegacy: relX,
                    yLegacy: relY,
                }
            })

            return { ...page, elements: updatedElements }
        }))

        // update selected element reference to reflect new parent/coords
        setSelectedElement(prev => {
            if (!prev) return prev
            if (!newParentId) {
                const nx = snapToGrid(absPos.x)
                const ny = Math.max(0, snapToGrid(absPos.y))
                return {
                    ...prev,
                    parentId: null,
                    xLegacy: nx,
                    yLegacy: ny,
                    x: { desktop: nx, tablet: nx, mobile: nx },
                    y: { desktop: ny, tablet: ny, mobile: ny },
                }
            }

            // moved into parent -> set to top-left inside the card (relative 0,0)
            const parentEl = pages.find(p => p.id === currentPageId)?.elements.find(pp => pp.id === newParentId)
            if (!parentEl) return prev
            const relX = 0
            const relY = 0
            return {
                ...prev,
                parentId: newParentId,
                xLegacy: relX,
                yLegacy: relY,
                x: { desktop: relX, tablet: relX, mobile: relX },
                y: { desktop: relY, tablet: relY, mobile: relY },
            }
        })
    }
    const getCardChildren = (cardId) => {
        const currentPageElements = pages.find(p => p.id === currentPageId)?.elements || []
        return currentPageElements.filter(el => el.parentId === cardId)
    }
    const getPageCards = () => {
        const currentPageElements = pages.find(p => p.id === currentPageId)?.elements || []
        return currentPageElements.filter(el => el.type === 'card')
    }
    const formColumnController =
        useCRUDController({
            onFinish: ({ axiosMode, status, values }) => {
                if (status === "success") {
                    if (axiosMode === "post") {

                    }
                }
                else if (status === "error") {
                    if (axiosMode === "post") {

                    }

                }
            },
            onBefore: () => { },
            apiRoute: formColumnApiRoute,
        });
    useEffect(() => {
        if (!currentPageId && elements?.length > 0) {
            setCurrentPageId(elements?.[(elements?.length) - 1 ?? 0]?.id)
        }
    }, [elements])
    useEffect(() => {
        onCanvasPageSelectChange(currentPageId);
    }, [currentPageId])
    useEffect(() => {
        onCanvasPageChange(pages);
    }, [pages])
    useEffect(() => {
        const handleKeyDown = (e) => {
            const active = document.activeElement
            const isInput = active && (
                active.tagName === "INPUT" ||
                active.tagName === "TEXTAREA" ||
                active.isContentEditable
            )
            if (isInput) {
                // 使用者正在編輯文字，不要刪掉元件
                return
            }
            // ✅ 若在編輯狀態就忽略鍵盤刪除
            if (editingElementId) return
            if ((e.key === "Backspace" || e.key === "Delete") && selectedElement) {
                e.preventDefault()
                handleDeleteSelectedElement()
            }
        }
        window.addEventListener("keydown", handleKeyDown)
        return () => {
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [selectedElement, editingElementId])
    useEffect(() => {
        // 沒有當前頁就不做
        if (!currentPage) return;

        // 掃描當前頁，找出需要重算的 straight-line 和 flow_line
        let changed = false;

        const newElements = currentPage.elements.map((el) => {
            // 處理 straight-line
            if (el?.type === 'straight-line' && el?.fromId && el?.toId) {
                const fromEl = currentPage.elements.find(x => x.id === el?.fromId);
                const toEl = currentPage.elements.find(x => x.id === el?.toId);
                if (!fromEl || !toEl) return el; // 缺端點，不更新

                const { bbox, rel } = computeLineGeom(fromEl, toEl, 0, canvasMode);

                // 若幾何資訊沒有實質變化，就直接回傳原物件
                const same =
                    nearly(el?.x, bbox.left) &&
                    nearly(el?.y, bbox.top) &&
                    nearly(el?.width, bbox.width) &&
                    nearly(el?.height, bbox.height) &&
                    el?.relP1 && el?.relP2 &&
                    nearly(el?.relP1.x, rel?.p1.x) &&
                    nearly(el?.relP1.y, rel?.p1.y) &&
                    nearly(el?.relP2.x, rel?.p2.x) &&
                    nearly(el?.relP2.y, rel?.p2.y);

                if (same) return el;

                changed = true;
                return {
                    ...el,
                    x: bbox.left,
                    y: bbox.top,
                    width: bbox.width,
                    height: bbox.height,
                    style: { ...(el?.style || {}), width: bbox.width, height: bbox.height },
                    relP1: rel?.p1,
                    relP2: rel?.p2,
                };
            }

            // 處理 flow_line
            if (el?.type === 'flow_line' && el?.fromId && el?.toId) {
                const fromEl = currentPage.elements.find(x => x.id === el?.fromId);
                const toEl = currentPage.elements.find(x => x.id === el?.toId);
                if (!fromEl || !toEl) return el; // 缺端點，不更新

                const { bbox, rel } = getEdgeCenterGeom(fromEl, toEl, canvasMode, /*padding=*/0);

                // 若幾何資訊沒有實質變化，就直接回傳原物件
                const same =
                    nearly(el?.x, bbox.left) &&
                    nearly(el?.y, bbox.top) &&
                    nearly(el?.width, bbox.width) &&
                    nearly(el?.height, bbox.height) &&
                    el?.relP1 && el?.relP2 &&
                    nearly(el?.relP1.x, rel?.p1.x) &&
                    nearly(el?.relP1.y, rel?.p1.y) &&
                    nearly(el?.relP2.x, rel?.p2.x) &&
                    nearly(el?.relP2.y, rel?.p2.y);

                if (same) return el;

                changed = true;
                return {
                    ...el,
                    x: bbox.left,
                    y: bbox.top,
                    width: bbox.width,
                    height: bbox.height,
                    style: { ...(el?.style || {}), width: bbox.width, height: bbox.height },
                    relP1: rel?.p1,
                    relP2: rel?.p2,
                };
            }

            // 其他元件不變
            return el;
        });

        if (!changed) return; // 沒變就不要 setPages，避免回圈

        // 只更新當前頁的 elements；其他頁保持原參考，避免整棵樹重建
        setPages(prev => prev.map(p =>
            p.id === currentPageId ? { ...p, elements: newElements } : p
        ));
    }, [pages, currentPageId, canvasMode]); // <- 依賴 pages：矩形移動/尺寸改變後會觸發

    //讓父代可以是使用到子代的function 這裡是為了避免setPages 造成無限回圈
    useImperativeHandle(ref, () => ({
        onUpdate(newPageData) {
            setPages(newPageData)
        },
        async captureThumbnail() {
            return captureThumbnail(); // 回傳 Blob，可父層轉 file
        },
        getStoreItem: (key) => getItem(key),  // ✅ 新增這行
    }));
    useEffect(() => {
        if (canvasMode !== "auto") return;
        // function handleResize() {
        //     const w = window.innerWidth;
        //     if (w >= 1000) setCanvasMode("desktop");
        //     else if (w >= 600) setCanvasMode("tablet");
        //     else setCanvasMode("mobile");
        // }
        // handleResize();
        // window.addEventListener("resize", handleResize);
        // return () => window.removeEventListener("resize", handleResize);
    }, [canvasMode]);
    return (<>
        <Dialog open={isAIModalOpen} onOpenChange={setIsAIModalOpen}>
            <DialogTrigger asChild>

            </DialogTrigger>
            <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle className="text-xl font-bold">AI 一鍵生成設定</DialogTitle>
                </DialogHeader>

                <div className="space-y-6 py-4">
                    {/* 1. 內容情境類型（必選） */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold text-gray-900">1. 內容情境類型（必選）</h3>
                        <p className="text-sm text-gray-600">選擇當前要製作的內容情境，影響推薦元件種類與配置</p>

                        <RadioGroup defaultValue="promotion">
                            <div className="grid grid-cols-2 gap-3">
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="promotion" id="promotion" />
                                    <Label htmlFor="promotion" className="text-sm">
                                        限時促銷活動
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="product-launch" id="product-launch" />
                                    <Label htmlFor="product-launch" className="text-sm">
                                        新品上市宣傳
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="brand-intro" id="brand-intro" />
                                    <Label htmlFor="brand-intro" className="text-sm">
                                        品牌形象介紹
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="unboxing" id="unboxing" />
                                    <Label htmlFor="unboxing" className="text-sm">
                                        開箱/使用分享
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="social-interaction" id="social-interaction" />
                                    <Label htmlFor="social-interaction" className="text-sm">
                                        社群互動貼文
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="event-preview" id="event-preview" />
                                    <Label htmlFor="event-preview" className="text-sm">
                                        活動預告/邀請
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="edm-content" id="edm-content" />
                                    <Label htmlFor="edm-content" className="text-sm">
                                        EDM 電子報內容
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="website-visual" id="website-visual" />
                                    <Label htmlFor="website-visual" className="text-sm">
                                        官網視覺區塊
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="course-service" id="course-service" />
                                    <Label htmlFor="course-service" className="text-sm">
                                        課程/服務推廣
                                    </Label>
                                </div>
                            </div>
                        </RadioGroup>
                    </div>

                    {/* <Separator /> */}

                    {/* 2. 元件項目選擇（多選） */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold text-gray-900">2. 元件項目選擇（多選）</h3>
                        <p className="text-sm text-gray-600">
                            選擇要包含的元件類型，AI 會根據選擇數量與內容情境，自動安排結構與順序
                        </p>

                        <div className="space-y-3">
                            <div className="flex gap-2 mb-3">
                                <Button variant="outline" size="sm">
                                    <Sparkles className="w-4 h-4 mr-1" />
                                    標準模式預設
                                </Button>
                                <Button variant="outline" size="sm">
                                    全選
                                </Button>
                                <Button variant="outline" size="sm">
                                    清除
                                </Button>
                            </div>

                            <div className="grid grid-cols-2 gap-3">
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="component-title" defaultChecked />
                                    <Label htmlFor="component-title" className="text-sm">
                                        <span className="font-medium">標題</span>
                                        <span className="text-gray-500 block text-xs">設定主題標語／吸睛開頭</span>
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="component-text" defaultChecked />
                                    <Label htmlFor="component-text" className="text-sm">
                                        <span className="font-medium">文字內容</span>
                                        <span className="text-gray-500 block text-xs">說明背景、特色、優惠等</span>
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="component-image" defaultChecked />
                                    <Label htmlFor="component-image" className="text-sm">
                                        <span className="font-medium">圖片（設計圖/插圖）</span>
                                        <span className="text-gray-500 block text-xs">用於視覺主視覺或圖說區塊</span>
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="component-photo" />
                                    <Label htmlFor="component-photo" className="text-sm">
                                        <span className="font-medium">照片（實拍圖）</span>
                                        <span className="text-gray-500 block text-xs">展示產品、情境、人物等</span>
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="component-video" />
                                    <Label htmlFor="component-video" className="text-sm">
                                        <span className="font-medium">影片</span>
                                        <span className="text-gray-500 block text-xs">附上影片腳本或畫面提示區塊</span>
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="component-hashtag" defaultChecked />
                                    <Label htmlFor="component-hashtag" className="text-sm">
                                        <span className="font-medium">Hashtag</span>
                                        <span className="text-gray-500 block text-xs">自動建議社群曝光標籤</span>
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="component-animation" />
                                    <Label htmlFor="component-animation" className="text-sm">
                                        <span className="font-medium">動畫</span>
                                        <span className="text-gray-500 block text-xs">簡短動態效果提示（轉場/浮動）</span>
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="component-audio" />
                                    <Label htmlFor="component-audio" className="text-sm">
                                        <span className="font-medium">音檔</span>
                                        <span className="text-gray-500 block text-xs">提供配音語句或音樂建議欄位</span>
                                    </Label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <Separator /> */}

                    {/* 3. 元件數量偏好（單選） */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold text-gray-900">3. 元件數量偏好（單選）</h3>
                        <p className="text-sm text-gray-600">控制畫面資訊密度與生成範圍</p>

                        <RadioGroup defaultValue="standard">
                            <div className="space-y-3">
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="simple" id="simple-mode" />
                                    <Label htmlFor="simple-mode" className="text-sm">
                                        <span className="font-medium">精簡模式</span>
                                        <span className="text-gray-500 block text-xs">生成 3～4 個元件（快速貼文）</span>
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="standard" id="standard-mode" />
                                    <Label htmlFor="standard-mode" className="text-sm">
                                        <span className="font-medium">標準模式</span>
                                        <span className="text-gray-500 block text-xs">生成 5～6 個元件（常用宣傳內容）</span>
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="rich" id="rich-mode" />
                                    <Label htmlFor="rich-mode" className="text-sm">
                                        <span className="font-medium">豐富模式</span>
                                        <span className="text-gray-500 block text-xs">生成 7～9 個元件（形象頁、完整介紹）</span>
                                    </Label>
                                </div>
                            </div>
                        </RadioGroup>
                    </div>

                    {/* <Separator /> */}

                    {/* 4. 元件排序策略（進階選填） */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold text-gray-900">4. 元件排序策略（進階選填）</h3>
                        <p className="text-sm text-gray-600">指定元件的優先順序，否則系統將依照最佳邏輯自動排序</p>

                        <div className="space-y-3">
                            <div className="flex items-center space-x-2">
                                <Checkbox id="auto-sort" defaultChecked />
                                <Label htmlFor="auto-sort" className="text-sm font-medium">
                                    使用系統推薦排序
                                </Label>
                            </div>

                            <div className="space-y-2">
                                <Label className="text-sm font-medium">自訂排序（選填）</Label>
                                <div className="grid grid-cols-2 gap-3">
                                    <div>
                                        <Label className="text-xs text-gray-600">第 1 個顯示</Label>
                                        <Select
                                            options={[
                                                { label: '標題', value: 'title' },
                                                { label: '圖片', value: 'image' },
                                                { label: '文字內容', value: 'text' },
                                                { label: '影片', value: 'video' },
                                            ]}
                                            placeholder="選擇元件..."
                                        />
                                    </div>
                                    <div>
                                        <Label className="text-xs text-gray-600">第 2 個顯示</Label>
                                        <Select
                                            options={[
                                                { label: '標題', value: 'title' },
                                                { label: '圖片', value: 'image' },
                                                { label: '文字內容', value: 'text' },
                                                { label: '影片', value: 'video' },
                                            ]}
                                            placeholder="選擇元件..."
                                        />
                                    </div>
                                    <div>
                                        <Label className="text-xs text-gray-600">第 3 個顯示</Label>
                                        <Select
                                            options={[
                                                { label: '標題', value: 'title' },
                                                { label: '圖片', value: 'image' },
                                                { label: '文字內容', value: 'text' },
                                                { label: '影片', value: 'video' },
                                            ]}
                                            placeholder="選擇元件..."
                                        />
                                    </div>
                                    <div>
                                        <Label className="text-xs text-gray-600">第 4 個顯示</Label>
                                        <Select
                                            options={[
                                                { label: '標題', value: 'title' },
                                                { label: '圖片', value: 'image' },
                                                { label: '文字內容', value: 'text' },
                                                { label: '影片', value: 'video' },
                                            ]}
                                            placeholder="選擇元件..."
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <Separator /> */}

                    {/* 5. 預覽呈現樣式（選填） */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold text-gray-900">5. 預覽呈現樣式（選填）</h3>
                        <p className="text-sm text-gray-600">提供不同畫布布局預覽樣式，供使用者先行模擬</p>

                        <RadioGroup defaultValue="single-column">
                            <div className="space-y-3">
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="single-column" id="single-column" />
                                    <Label htmlFor="single-column" className="text-sm">
                                        <span className="font-medium">單欄式</span>
                                        <span className="text-gray-500 block text-xs">適合社群、手機簡約設計</span>
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="left-image-right-text" id="left-image-right-text" />
                                    <Label htmlFor="left-image-right-text" className="text-sm">
                                        <span className="font-medium">左圖右文</span>
                                        <span className="text-gray-500 block text-xs">適合品牌介紹與商品導購</span>
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="card-blocks" id="card-blocks" />
                                    <Label htmlFor="card-blocks" className="text-sm">
                                        <span className="font-medium">區塊式卡片</span>
                                        <span className="text-gray-500 block text-xs">適合 EDM、產品展示</span>
                                    </Label>
                                </div>
                            </div>
                        </RadioGroup>
                    </div>

                    <div className="flex justify-end gap-3 pt-6 border-t">
                        <Button variant="outline" onClick={() => setIsAIModalOpen(false)}>
                            取消
                        </Button>
                        <Button className="bg-blue-500 hover:bg-blue-600">
                            <Sparkles className="w-4 h-4 mr-2" />
                            開始生成
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
        <div
            className="flex-1 flex flex-col"
        >
            {/* Toolbar */}
            {showToolbar && <div className="bg-white border-b border-gray-200 p-3">
                <div className="flex flex-wrap xl:flex-nowrap items-center justify-between gap-2">
                    <div className="flex flex-wrap xl:flex-nowrap items-center gap-2 w-full">
                        {/* 只在設計模式顯示這些按鈕 */}
                        {/* {mode === "design" && (
                            <>
                                <Button variant="ghost" size="sm">
                                    <Undo2 className="w-4 h-4" />
                                </Button>
                                <Button variant="ghost" size="sm">
                                    <Redo2 className="w-4 h-4" />
                                </Button>
                            </>
                        )} */}
                        {/* 版面切換按鈕（都顯示） */}
                        <div className="flex items-center gap-2">
                            {Object.entries(CANVAS_SIZES)
                                .filter(([modeKey, { label, icon }]) => {
                                    return modeKey !== "auto"
                                })
                                .map(([modeKey, { label, icon }]) => (
                                    <Button
                                        key={modeKey}
                                        variant={canvasMode === modeKey ? "default" : "outline"}
                                        size="sm"
                                        onClick={() => setCanvasMode(modeKey)}
                                    >
                                        <LucideIcon className="w-4 h-4" name={icon} />
                                        <span className="ml-1">{label}</span>
                                    </Button>
                                ))}
                        </div>
                        {/* 只在設計模式顯示這些按鈕 */}
                        {mode === "design" && (
                            <>
                                <Button variant="ghost" size="sm" onClick={handleDeleteSelectedElement} >
                                    <Trash2 className="w-4 h-4" />
                                </Button>
                                {/* <Button variant="ghost" size="sm" onClick={handleClearCurrentPage}> */}
                                <Button variant="ghost" size="sm" onClick={handleClearCurrentPageConfirm}>
                                    <X className="w-4 h-4" />
                                </Button>
                                <Button variant="ghost" size="sm" onClick={handleShowCurrentPageGrid}>
                                    <Grid3X3 className="w-4 h-4" />
                                </Button>
                            </>
                        )}
                        {/* 百分比縮放（都顯示） */}
                        <Button
                            variant="ghost" size="sm"
                            onClick={() => handleZoomChange(Math.max((pages.find((page) => page.id === currentPageId)?.zoom ?? 1) - 0.1, 0.1))}
                        >
                            <ZoomOut className="w-4 h-4" />
                        </Button>
                        <Input
                            type="number"
                            value={Math.round((pages.find((page) => page.id === currentPageId)?.zoom ?? 1) * 100)}
                            onChange={(e) => {
                                const val = parseInt(e.target.value, 10);
                                if (!isNaN(val)) {
                                    handleZoomChange(Math.min(Math.max(val / 100, 0.1), 3));
                                }
                            }}
                            style={{ width: '80px' }}
                        />
                        <span>%</span>
                        <Button
                            variant="ghost" size="sm"
                            onClick={() => handleZoomChange(Math.min((pages.find((page) => page.id === currentPageId)?.zoom ?? 1) + 0.1, 3))}
                        >
                            <ZoomIn className="w-4 h-4" />
                        </Button>
                        {/* 只在設計模式顯示重整 */}
                        {mode === "design" && (
                            <Button variant="ghost" size="sm" onClick={handleResetCurrentPageView}>
                                <RefreshCw className="w-4 h-4" />
                            </Button>
                        )}
                        {/* 上層傳下來的工具（都顯示） */}
                        {tools?.map((tool, idx) => (
                            <Button
                                key={idx}
                                variant={tool?.variant || "outline"}
                                size={tool?.size || "sm"}
                                onClick={tool?.onClick}
                                className={tool?.className}
                            >
                                {tool?.icon && <LucideIcon className="w-4 h-4 mr-1" name={tool?.icon} />}
                                {tool?.label}
                            </Button>
                        ))}
                    </div>
                </div>
            </div>}
            {/* External Block */}
            {renderExternalBlock()}
            {/* Page Navigation */}
            {
                showToolbar && <div className="bg-white border-b border-gray-200 p-3">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-2">
                        <div className="flex items-center gap-2 max-w-full overflow-x-auto ">
                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={goToPreviousPage}
                                disabled={pages.findIndex((page) => page.id === currentPageId) === 0}
                            >
                                <ChevronLeft className="w-4 h-4" />
                            </Button>

                            <div className="flex items-center gap-2 max-w-md overflow-x-auto ">
                                {pages.map((page, index) => (
                                    <div
                                        key={page.id}
                                        className={`flex items-center gap-2 px-3 py-2 rounded-lg border cursor-pointer transition-colors ${page.id === currentPageId
                                            ? "bg-blue-50 border-blue-200 text-blue-700"
                                            : "bg-gray-50 border-gray-200 hover:bg-gray-100"
                                            }`}
                                        onClick={() => {
                                            setCurrentPageId(page.id)
                                            setSelectedElement(null)
                                        }}
                                    >
                                        <div className="w-8 h-6 bg-white border rounded flex items-center justify-center text-xs">
                                            {index + 1}
                                        </div>
                                        <span className="text-sm font-medium whitespace-nowrap">{page.name}</span>

                                        <DropdownMenu>
                                            <DropdownMenuTrigger asChild>
                                                <Button variant="ghost" size="sm" className="w-4 h-4 p-0">
                                                    <MoreHorizontal className="w-3 h-3" />
                                                </Button>
                                            </DropdownMenuTrigger>
                                            <DropdownMenuContent>
                                                <DropdownMenuItem onClick={() => duplicatePage(page.id)}>
                                                    <Copy className="w-4 h-4 mr-2" />
                                                    複製頁面
                                                </DropdownMenuItem>
                                                <DropdownMenuItem
                                                    onClick={() => {
                                                        const newName = prompt("請輸入新的頁面名稱:", page.name)
                                                        if (newName && newName.trim()) {
                                                            renamePage(page.id, newName.trim())
                                                        }
                                                    }}
                                                >
                                                    <Edit3 className="w-4 h-4 mr-2" />
                                                    重新命名
                                                </DropdownMenuItem>
                                                {pages.length > 1 && (
                                                    <DropdownMenuItem onClick={() => deletePage(page.id)} className="text-red-600">
                                                        <Trash2 className="w-4 h-4 mr-2" />
                                                        刪除頁面
                                                    </DropdownMenuItem>
                                                )}
                                            </DropdownMenuContent>
                                        </DropdownMenu>
                                    </div>
                                ))}
                            </div>

                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={goToNextPage}
                                disabled={pages.findIndex((page) => page.id === currentPageId) === pages.length - 1}
                            >
                                <ChevronRight className="w-4 h-4" />
                            </Button>
                        </div>
                        {mode === "design" && (
                            <Button variant="outline" size="sm" onClick={addNewPage}>
                                <Plus className="w-4 h-4 mr-2" />新增頁面
                            </Button>
                        )}
                    </div>
                </div>
            }
            {/* Canvas Area — 雙軌策略：fill 模式走文件流 RWD，design 模式保留原本 absolute 畫布 */}
            {(mode === "fill" || mode === "fill_disable") ? (
                /* ── fill / fill_disable 模式：文件流排版 ── */
                <div className="flex-1 overflow-auto">
                    <div className="w-full">
                        <CanvasFlowLayout
                            elements={pages.find(p => p.id === currentPageId)?.elements || []}
                            canvasMode={canvasMode}
                            canvasWidth={
                                canvasMode === "auto" ? (typeof window !== "undefined" ? window.innerWidth : 1200)
                                    : ({ desktop: 1200, tablet: 800, mobile: 375 }[canvasMode] ?? 1200)
                            }
                            mode={mode}
                            renderElement={(element) => {
                                // 組出動態資料（同 design 模式的 reconbineElement 邏輯）
                                let reconbineElement = { ...element }
                                let form_form_column_data = reconbineElement?.form_form_column_data || []
                                let newForm_form_column_data = form_form_column_data.map((column) => {
                                    let newForm_column_source_data = column?.form_column_source_data?.map((source) => {
                                        let newDocument_source_data = source?.document_source_data?.map((doc) => {
                                            if (!getItem(doc?.document_id)?.response_data) {
                                                getOrFetchItem(doc?.document_id, "/utility/response/cache", false)
                                            }
                                            return { ...doc, response_data: getItem(doc?.document_id)?.response_data || [] }
                                        })
                                        return { ...source, document_source_data: newDocument_source_data }
                                    })
                                    return { ...column, form_column_source_data: newForm_column_source_data }
                                })
                                reconbineElement.form_form_column_data = newForm_form_column_data

                                return (
                                    <RenderFillComponent
                                        mode={mode}
                                        element={reconbineElement}
                                        selectedType={selectedType}
                                        selectedElement={selectedElement}
                                        setSelectedElement={setSelectedElement}
                                        getCardChildren={getCardChildren}
                                        updateElementContent={updateElementContent}
                                        isEditing={editingElementId === element?.id}
                                        handleElementClick={handleElementClick}
                                        getOrFetchItem={getOrFetchItem}
                                        getItem={getItem}
                                        editableFieldCodes={editableFieldCodes}
                                        canvasMode={canvasMode}
                                    />
                                )
                            }}
                        />
                    </div>
                </div>
            ) : (
                /* ── design 模式：原本的 absolute 畫布（完整保留） ── */
                <div
                    className="flex-1 bg-gray-100 p-8 flex overflow-auto"
                    onMouseMove={(e) => {
                        handleMouseMove(e);
                        handleResizeMouseMove(e);
                    }}
                    onMouseUp={() => {
                        handleMouseUp();
                        handleResizeMouseUp();
                    }}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={handleDropOnCanvas}
                >
                    <div>
                        <div
                            ref={canvasCaptureRef}
                            className="bg-white rounded-lg shadow-sm relative"
                            style={{
                                width: canvasMode === "auto" ? "95vw" : `${CANVAS_SIZES[canvasMode]?.width}px`,
                                height: canvasMode === "auto" ? "100%" : `${CANVAS_SIZES[canvasMode]?.height}px`,
                                // Always show grid in display mode
                                backgroundImage: (
                                    ((pages.find(page => page.id === currentPageId)?.showGrid ?? false) || mode === "design")
                                )
                                    ? `
                                linear-gradient(rgba(0,0,0,0.1) 1px, transparent 1px),
                                linear-gradient(90deg, rgba(0,0,0,0.1) 1px, transparent 1px)
                            `
                                    : 'none',
                                backgroundSize: "20px 20px",
                                transform: `scale(${(pages.find((page) => page.id === currentPageId)?.zoom ?? 1)})`,
                                transformOrigin: "top left",
                                maxWidth: "100vw",
                                minHeight: "100vh",
                                // maxHeight: "80vh",
                            }}
                        >
                            {/* Ruler - 上方 */}
                            <div className="absolute -top-8 left-0 right-0 h-8 pointer-events-none select-none z-20">
                                {/* 數字層 */}
                                <div className="absolute top-0 left-0 right-0 h-4 flex">
                                    {Array.from({ length: horizontalSteps }, (_, i) => (
                                        <div key={i} className="w-5 text-center relative">
                                            {i % 5 === 0 &&
                                                <span className="text-xs text-gray-500" style={{ position: "absolute", left: 0, right: 0 }}>{i * 20}</span>
                                            }
                                        </div>
                                    ))}
                                </div>
                                {/* 刻度線層 */}
                                <div className="absolute bottom-0 left-0 right-0 h-4 flex">
                                    {Array.from({ length: horizontalSteps }, (_, i) => (
                                        <div key={i} className="w-5 flex justify-center">
                                            <div
                                                style={{
                                                    width: 1,
                                                    height: i % 5 === 0 ? 16 : 8,
                                                    background: "#d1d5db",
                                                    margin: "0 auto"
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Ruler - 左側 */}
                            <div className="absolute -left-8 top-0 bottom-0 w-8 pointer-events-none select-none z-20">
                                {/* 數字層 */}
                                <div className="absolute left-0 top-0 bottom-0 w-8 flex flex-col">
                                    {Array.from({ length: verticalSteps }, (_, i) => (
                                        <div key={i} className="h-5 relative flex items-start">
                                            {i % 5 === 0 &&
                                                <span className="text-xs text-gray-500 absolute left-0 top-0">{i * 20}</span>
                                            }
                                        </div>
                                    ))}
                                </div>
                                {/* 刻度線層 */}
                                <div className="absolute right-0 top-0 bottom-0 w-4 flex flex-col">
                                    {Array.from({ length: verticalSteps }, (_, i) => (
                                        <div key={i} className="h-5 flex items-start justify-end">
                                            <div
                                                style={{
                                                    width: i % 5 === 0 ? 16 : 8,
                                                    height: 1,
                                                    background: "#d1d5db"
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Canvas Elements */}
                            {/* {canvasElements.map((element) => { */}
                            {/* // 修改 Canvas Elements 渲染，右下角加 resize handle */}
                            {pages.find((page) => page.id === currentPageId)
                                ?.elements
                                ?.filter((ele) => !ele?.parentId)
                                ?.map((element) => {
                                    const isEditing = editingElementId === element?.id
                                    const { x, y } = getElementPosition(element, canvasMode);
                                    // 判斷是否表單類型
                                    const isFormType = [
                                        "text-content", "number_input", "dropdown", "checkbox", "radio_button",
                                        "datetime_picker", "multi_select_list", "textarea", "email_input",
                                        "phone_input", "url_input", "password_input", ""
                                    ].includes(element?.type);
                                    // 不顯示群組分類的元件陣列
                                    const noContainerElements = ["card", "flow_line", "straight-line", "flow_node", "end_node", "process_node", "decision_node", 'flow_line', 'start_node'];
                                    const isShowContainerControl = mode === "design" && !noContainerElements.includes(element?.type)
                                    // 不顯示邊框的元件陣列
                                    const noBorderElements = ["flow_line", "straight-line"];
                                    // 判斷是否顯示藍色框
                                    const showBlueBorder = mode === "design" && selectedElement?.id === element?.id;
                                    let showBorder = mode === "design" && !noBorderElements.includes(element?.type)
                                    // 組出動態資料
                                    let reconbineElement = { ...element };
                                    let form_form_column_data = reconbineElement?.form_form_column_data || []
                                    let newForm_form_column_data = form_form_column_data.map((column) => {
                                        let newForm_column_source_data = column?.form_column_source_data?.map((source) => {
                                            let newDocument_source_data = source?.document_source_data?.map((doc) => {
                                                // build a sensible filter object if present on source or doc
                                                const filter = column?.form_column_filter_data || []
                                                // fire-and-forget if not cached yet for this document+filter
                                                if (!getItem(doc?.document_id, filter)?.response_data) {
                                                    getOrFetchItem(doc?.document_id, "/utility/response/cache", false)
                                                }

                                                return {
                                                    ...doc,
                                                    response_data: getItem(doc?.document_id)?.response_data || []
                                                }
                                            })
                                            return {
                                                ...source,
                                                document_source_data: newDocument_source_data
                                            }
                                        })
                                        return {
                                            ...column,
                                            form_column_source_data: newForm_column_source_data
                                        }
                                    })
                                    element.form_form_column_data = newForm_form_column_data;
                                    return (
                                        (element?.hidden !== 1) &&
                                        <div
                                            key={element?.id}
                                            className={`group absolute transition-all ${showBlueBorder ? 'ring-2 ring-blue-400 rounded-md' : ''} ${showBorder ? "border border-dashed border-slate-300" : ""} ${mode === "design" ? "rounded-md p-2" : ""}`}
                                            // className={`absolute ${showBlueBorder ? "border-2 border-blue-500" : "border-transparent"} hover:border-blue-300`}
                                            style={{
                                                left: x,
                                                top: y,
                                                width: getElementSize(element, canvasMode).width || undefined,
                                                height: getElementSize(element, canvasMode).height || undefined,
                                                ...element?.style,
                                                // style 裡的 width/height 若是 object，也要取當前裝置的值
                                                ...(typeof element?.style?.width === "object" ? { width: element?.style?.width?.[canvasMode] ?? element?.style?.width?.desktop } : {}),
                                                ...(typeof element?.style?.height === "object" ? { height: element?.style?.height?.[canvasMode] ?? element?.style?.height?.desktop } : {}),
                                                ...(mode !== "design" ? { overflow: 'visible', height: 'auto', minHeight: 0 } : {}),
                                                pointerEvents: 'none',
                                                cursor: isEditing ? "text" : (mode === "design" ? "pointer" : "default"),
                                            }}
                                            onClick={() => {
                                                // console.log({
                                                //     element
                                                // })
                                                if (mode === "design" && !isEditing) handleElementClick(element)
                                            }}
                                            id={`element-${element?.id}`}
                                            onMouseDown={(e) => {
                                                if (mode === "design" && connectionMode === "none" && element?.type !== "straight-line" && element?.type !== "flow_line") {
                                                    handleMouseDown(e, element)
                                                }
                                            }}
                                            onDoubleClick={() => {
                                                if (mode === "design") {
                                                    if (element?.type === "datetime") {
                                                        // ...existing code...
                                                    } else if (element?.type === "qrcode") {
                                                        setEditingElementId(null)
                                                        setEditingContent("")
                                                    } else {
                                                        setEditingElementId(element?.id);
                                                        setEditingContent(element?.content);
                                                    }
                                                }
                                            }}
                                        >
                                            {/* Container assign control (top-left) - for non-card elements */}
                                            {isShowContainerControl && (
                                                <div
                                                    style={{
                                                        pointerEvents: 'auto',
                                                    }}
                                                    className={`absolute -top-12 left-0 z-20 flex items-center gap-2 ${selectedElement?.id === element?.id ? 'opacity-100' : 'opacity-0 pointer-events-none'} transition-opacity`}>
                                                    {(() => {
                                                        let parent = pages.find(page => page.id === currentPageId)?.elements.find(el => el?.id === element?.id)
                                                        let cardElements = pages.find(page => page.id === currentPageId)?.elements.filter(el => el.type === 'card' && !el.parentId)
                                                        const parentLabel = parent ? (parent?.label || '群組卡片') : '無'
                                                        return (
                                                            <span
                                                                className="leading-none rounded px-2 py-[-3px] bg-slate-800 text-white shadow cursor-default select-none"
                                                                title={`當前群組：${parentLabel}`}
                                                                onMouseDown={(e) => e.stopPropagation()}
                                                            >
                                                                群組：
                                                                <select
                                                                    className="h-6 text-[11px] rounded border text-black px-1 pr-5 shadow cursor-pointer"
                                                                    value={element?.parentId || ''}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value || null
                                                                        handleChangeContainer(val)
                                                                    }}
                                                                    title="選擇群組"
                                                                >
                                                                    <option value="">無群組（獨立）</option>
                                                                    {cardElements.filter(el => el.type === 'card' && !el.parentId).map(card => (
                                                                        <option key={card.id} value={card.id}>{card.label || '群組卡片'}</option>
                                                                    ))}
                                                                </select>
                                                            </span>
                                                        )
                                                    })()}

                                                </div>
                                            )}
                                            {mode === "fill" && (
                                                // 填寫模式下，表單元件直接顯示可填寫表單
                                                <RenderFillComponent
                                                    mode={"fill"}
                                                    element={element}
                                                    selectedType={selectedType}
                                                    selectedElement={selectedElement}
                                                    setSelectedElement={setSelectedElement}
                                                    getCardChildren={getCardChildren}
                                                    updateElementContent={updateElementContent}
                                                    isEditing={isEditing}
                                                    handleElementClick={handleElementClick}
                                                    getOrFetchItem={getOrFetchItem}
                                                    getItem={getItem}
                                                    editableFieldCodes={editableFieldCodes}
                                                />
                                            )}
                                            {mode === "fill_disable" && (
                                                // 填寫模式下，表單元件直接顯示可填寫表單
                                                <RenderFillComponent
                                                    mode={"fill_disable"}
                                                    element={element}
                                                    selectedType={selectedType}
                                                    selectedElement={selectedElement}
                                                    setSelectedElement={setSelectedElement}
                                                    getCardChildren={getCardChildren}
                                                    updateElementContent={updateElementContent}
                                                    isEditing={isEditing}
                                                    handleElementClick={handleElementClick}
                                                    getOrFetchItem={getOrFetchItem}
                                                    getItem={getItem}
                                                    editableFieldCodes={editableFieldCodes}
                                                />
                                            )}
                                            {mode === "design" && (
                                                isEditing ? (
                                                    <textarea
                                                        autoFocus
                                                        className="w-full h-full resize-none p-1 text-sm border rounded"
                                                        value={editingContent}
                                                        onChange={(e) => setEditingContent(e.target.value)}
                                                        onBlur={() => handleFinishEditing()}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" && !e.shiftKey) {
                                                                e.preventDefault()
                                                                handleFinishEditing()
                                                            }
                                                        }}
                                                    />
                                                ) : (
                                                    <RenderDisplayComponent
                                                        element={element}
                                                        selectedElement={selectedElement}
                                                        selectedType={selectedType}
                                                        connectionMode={connectionMode}
                                                        connectionState={connectionState}
                                                        setSelectedElement={setSelectedElement}
                                                        setPages={setPages}
                                                        addChildNode={addChildNode}
                                                        handleDeleteSelectedElement={handleDeleteSelectedElement}
                                                        startConnection={startConnection}
                                                        finishConnection={finishConnection}
                                                        cancelConnection={cancelConnection}
                                                        createConnectedNode={createConnectedNode}
                                                        canvasMode={canvasMode}
                                                        getPriorityColor={getPriorityColor}
                                                        getPriorityText={getPriorityText}
                                                        getLineStyle={getLineStyle}
                                                        getEdgeCenterGeom={getEdgeCenterGeom}
                                                        computeLineGeom={computeLineGeom}
                                                        handleElementClick={handleElementClick}
                                                        currentPageId={currentPageId}
                                                        setConnectionMode={setConnectionMode}
                                                        currentPage={currentPage}
                                                        getCardChildren={getCardChildren}
                                                        getPageCards={getPageCards}
                                                        // onDropElement={handleDropIntoCard}
                                                        CARD_INNER_PADDING={CARD_INNER_PADDING}
                                                        mode={mode}
                                                        isEditing={isEditing}
                                                        setEditingElementId={setEditingElementId}
                                                        handleMouseDown={handleMouseDown}
                                                        setEditingContent={setEditingContent}
                                                        RenderFillComponent={RenderFillComponent}
                                                        updateElementContent={updateElementContent}
                                                        editingContent={editingContent}
                                                        handleFinishEditing={handleFinishEditing}
                                                        handleResizeMouseDown={handleResizeMouseDown}
                                                        showBlueBorder={showBlueBorder}
                                                        handleMouseMove={handleMouseMove}
                                                        handleResizeMouseMove={handleResizeMouseMove}
                                                        handleMouseUp={handleMouseUp}
                                                        handleResizeMouseUp={handleResizeMouseUp}
                                                        handleChangeContainer={handleChangeContainer}
                                                        getOrFetchItem={getOrFetchItem}
                                                        getItem={getItem}
                                                    />
                                                )
                                            )}
                                            {/* 拖拉縮放手柄，只在設計模式顯示 */}
                                            {mode === "design" && !["flow_line", "straight-line"].includes(element?.type) && (
                                                <div
                                                    className="absolute right-0 bottom-0 w-4 h-4 bg-blue-400 rounded cursor-nwse-resize flex items-center justify-center  pointer-events-auto"
                                                    style={{ zIndex: 10 }}
                                                    onMouseDown={(e) => handleResizeMouseDown(e, element)}
                                                >
                                                    <svg width="12" height="12">
                                                        <polyline points="0,12 12,12 12,0" stroke="white" strokeWidth="2" fill="none" />
                                                    </svg>
                                                </div>
                                            )}
                                            {/* 右上角藍色圓點，只在設計模式顯示 */}
                                            {showBlueBorder && mode === "design" && (
                                                <div className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full cursor-move pointer-events-auto"></div>
                                            )}
                                        </div>
                                    )
                                })}

                            {/* Empty Canvas Message */}
                            {(pages.find((page) => page.id === currentPageId)?.elements.length ?? 0) === 0 && (
                                <div className="absolute inset-0 flex items-center justify-center">
                                    <div className="text-center text-gray-400">
                                        <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-lg flex items-center justify-center">
                                            <Edit3 className="w-8 h-8" />
                                        </div>
                                        <p className="text-lg font-medium mb-2">開始創建您的設計</p>
                                        <p className="text-sm">從左側選擇元件並拖拉到畫布上</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                /* ── design 模式結束 ── */
            )}
        </div >
        <Dialog
            open={dateTimeModalOpen}
            onOpenChange={(open) => {
                setDateTimeModalOpen(open);
                if (!open) {
                    setDateTimeModalElement(null);
                    setDateTimeModalTempContent("");
                }
            }}
        >
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>選擇日期時間</DialogTitle>
                </DialogHeader>
                {dateTimeModalElement && (
                    <div className="space-y-4">
                        <NewDatePicker.DatePickerIncludeMinute
                            value={dateTimeModalTempContent}
                            onChange={(e) => {
                                setDateTimeModalTempContent(formatDateTimeWithSeconds(e));
                            }}
                        />

                        <div className="flex justify-end gap-2 pt-4">
                            <Button variant="outline" onClick={() => setDateTimeModalOpen(false)}>取消</Button>
                            <Button onClick={handleSaveDateTimeModal}>儲存</Button>
                        </div>
                    </div>
                )}
            </DialogContent>
        </Dialog>


        {/* Clear Page Confirmation Modal */}
        <Dialog open={isClearConfirmOpen} onOpenChange={setIsClearConfirmOpen}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>確定要清除整個頁面嗎？</DialogTitle>
                </DialogHeader>
                <div className="py-2">
                    <p className="text-sm text-gray-600">此動作會移除目前頁面上的所有元件，無法還原，請確認。</p>
                    <div className="flex justify-end gap-2 pt-4">
                        <Button variant="outline" onClick={cancelClearCurrentPage}>取消</Button>
                        <Button className="bg-red-500 hover:bg-red-600" onClick={confirmClearCurrentPage}>確定清除</Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
        <Dialog
            open={dateTimeModalOpen}
            onOpenChange={(open) => {
                setDateTimeModalOpen(open);
                if (!open) {
                    setDateTimeModalElement(null);
                    setDateTimeModalTempContent("");
                }
            }}
        ></Dialog>
    </>)
})

export default BaseCanvasEdit2;
